import React, {FunctionComponent} from 'react';
import {Page} from 'b302-frontend-library';
import {useParams} from 'react-router-dom';
import {useQuery} from '@tanstack/react-query';

import {useUniversityDetailQueryConfig} from '../../../query/University/Query';
import {useResponseWithoutPaginationQueryConfig} from '../../../query/Response/Query';
import ContactContent from './ContactContent';

const Contact: FunctionComponent = () => {
    const { id } = useParams();

    const universityId = Number(id);

    const [universityConfig] = useUniversityDetailQueryConfig(universityId);
    const [responseConfig] = useResponseWithoutPaginationQueryConfig(universityId, {
        contactable: 1
    });

    const universityQuery = useQuery(universityConfig);
    const responseQuery = useQuery(responseConfig);

    return (
        <Page className={'contact-page'}>
            { (universityQuery.data && responseQuery.data) &&
                <ContactContent
                    university={universityQuery.data}
                    responses={responseQuery.data} />
            }
        </Page>
    );
};

export default Contact;
